import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import CustomerTracking from '@/pages/CustomerTracking';
import CustomerDashboard from '@/pages/CustomerDashboard';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import TicketDetail from '@/pages/TicketDetail';
import AdminSettings from '@/pages/AdminSettings';
import WorkOrders from '@/pages/WorkOrders';
import WorkOrderDetail from '@/pages/WorkOrderDetail';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/customer/tracking" element={<CustomerTracking />} />
          <Route path="/customer/dashboard" element={<CustomerDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/ticket/:ticketId" element={<TicketDetail />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/work-orders" element={<WorkOrders />} />
          <Route path="/admin/work-orders/:workOrderId" element={<WorkOrderDetail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;